module.exports = __webpack_public_path__ + "media/images/arrow-left-black-1cb55329f709c279b1ca46a4052fa733.svg";